import { render, staticRenderFns } from "./case-contract-tab.vue?vue&type=template&id=6bbaf57a&"
import script from "./case-contract-tab.vue?vue&type=script&lang=js&"
export * from "./case-contract-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports